import { useState } from "react";

type BlockedBookingStatus = Exclude<BookingTimeStatus, "ok">;

export type BookingTimeStatus = "ok" | "not-open" | "closed";

function getBookingTimeStatus(now = new Date()): BookingTimeStatus {
  const hour = now.getHours();
  const minute = now.getMinutes();

  // Mở đăng ký khám từ 07:30 sáng đến 10:00 tối
  const isBeforeOpenTime = hour < 6 || (hour === 6 && minute < 30);
  const isAfterCloseTime = hour >= 22;

  if (isBeforeOpenTime) return "not-open";
  if (isAfterCloseTime) return "closed";

  return "ok";
}

export function useBookingTimeGuard() {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogType, setDialogType] = useState<BlockedBookingStatus>("closed");

  const checkBookingTime = () => {
    const status = getBookingTimeStatus();

    if (status !== "ok") {
      setDialogType(status);
      setDialogOpen(true);
      return false;
    }

    return true;
  };

  return {
    checkBookingTime,
    dialogOpen,
    dialogType,
    closeDialog: () => setDialogOpen(false),
  };
}